<div class="flex flex--top fill ps-xsmall-t">
  <fcom-icon
    class="icon-medium ms-xsmall-r"
    [attr.aria-label]="
      (completed ? 'MMB.apis.passenger.fieldCompleted' : 'MMB.apis.passenger.fieldNotCompleted') | finLocalization
    "
    [name]="completed ? SvgLibraryIcon.CHECKMARK : SvgLibraryIcon.ALERT_BLOCK"
    [ngClass]="{ 'birch-900-text': completed, 'br-red': !completed }"
  ></fcom-icon>
  <span class="flex-1 font-body-1 flex align-left flex--wrap">
    {{ translationKey | finLocalization }}
  </span>
</div>
